import React, { Component } from 'react'
import GoogleMapReact from 'google-map-react'
import { MapPin } from 'react-feather'

let mapkey = ''
if (process.env.NETLIFY_MAP_KEY) {
  mapkey = process.env.NETLIFY_MAP_KEY
}

class GoogleMap extends Component {
  static defaultProps = {
    center: {
      lat: 35.708436,
      lng: 139.7737824
    },
    zoom: 14
  }

  render() {
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: '50vh', width: '100%' }}>
        <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3793.087900690165!2d139.7742304699323!3d35.70830057169619!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188e9f7d1c4e79%3A0xe15e9d6fd6e70426!2z44CSMTEwLTAwMDUg5p2x5Lqs6YO95Y-w5p2x5Yy65LiK6YeO77yW5LiB55uu77yR4oiS77yR77yRIOW5s-WyoeODk-ODqzlG!5e0!3m2!1sja!2sjp!4v1565194713202!5m2!1sja!2sjp" 
        width="100%" height="100%" frameborder="0" allowfullscreen></iframe>
        {/* <GoogleMapReact
          bootstrapURLKeys={{ key: mapkey }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <Marker lat={35.708436} lng={139.7737824} text={'Kreyser Avrora'} />
        </GoogleMapReact> */}
      </div>
    )
  }
}

export default GoogleMap

const Marker = () => {
  return (
    <div style={{ color: 'red' }}>
      <MapPin />
    </div>
  )
}
